var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10777",
    "data-name": "Grupo 10777",
    transform: "translate(-37 -480)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10778",
    "data-name": "Grupo 10778"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_96",
    "data-name": "Elipse 96",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(37 480)",
    fill: "#e41033",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1565",
    "data-name": "Trazado 1565",
    d: "M23,0A23,23,0,1,1,0,23,23,23,0,0,1,23,0Z",
    transform: "translate(44 487)",
    fill: "#e41033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-fire",
    "data-name": "Icon metro-fire",
    d: "M12.241,32.777c-2.056-4.278-.961-6.729.619-9.039A14.4,14.4,0,0,0,15.037,18.7a5.913,5.913,0,0,1,.816,4.534,11.443,11.443,0,0,0,2.494-8.57c5.432,3.8,7.754,12.016,4.625,18.107,16.64-9.415,4.139-23.5,1.963-25.09.725,1.587.863,4.273-.6,5.577C21.851,3.856,15.717,1.928,15.717,1.928c.725,4.852-2.63,10.157-5.865,14.121A10.485,10.485,0,0,0,8.6,10.928c-.228,3.514-2.914,6.379-3.641,9.9C3.973,25.6,5.7,29.088,12.241,32.777Z",
    transform: "translate(49.299 493.072)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.30dcb7dfbdbb78416b293ff4cf891ef2.svg";
export { ForwardRef as ReactComponent };